<template>
  <div class="card">
    <Spinner :isLoading="isLoading" />
    <h2 class="text-center mt-5 mb-4 title-header">Job Applications</h2>
    <section id="application-content" class="myapplications">
      <div class="container">
        <section class="latest-ads">
          <h2 v-if="applications.length === 0" class="text-center">No job applications</h2>
          <div class="row">
            <!-- Left Col -->
            <div class="col-md-12">
              <!-- Single Job Post -->
              <div
                v-for="job in applications"
                :key="job.id"
                class="single d-flex align-items-center"
              >
                <router-link :to="{ name: 'user-jobs', params: { jobad_id: job.job_id } }">
                  <img
                    v-if="job.anonymize"
                    :src="require(`../../../public/img/homepage/customer-logos/comstream-logo.png`)"
                    :alt="job.title"
                  />
                  <span v-else>
                    <img
                      v-if="
                        job.photo !== null &&
                          job.photo !== 'default.png' &&
                          job.photo !== 'null' &&
                          job.photo !== ''
                      "
                      :src="`https://jobshark.eu/storage/employers/logos/${job.photo}`"
                      :alt="job.title"
                    />
                    <img
                      v-else
                      :src="require(`../../../public/img/comstream.svg`)"
                      :alt="job.title"
                    />
                  </span>
                </router-link>
                <div class="job-info">
                  <router-link :to="{ name: 'user-jobs', params: { jobad_id: job.job_id } }">{{
                    job.job
                  }}</router-link>
                  <router-link :to="{ name: 'user-jobs', params: { jobad_id: job.job_id } }">{{
                    job.employer
                  }}</router-link>
                </div>
                <span class="documents mx-auto d-flex" v-if="job.documents.length > 0">
                  <span
                    @click="openDocPreview(document.id, document.name)"
                    v-for="document in job.documents"
                    :key="document.id"
                    class="mr-3"
                    :title="document.name"
                    style="color: Red"
                    ><i style="cursor: pointer" :class="`fa ${document.icon}`"></i
                  ></span>
                </span>
                <span v-else class="documents mx-auto d-flex"
                  ><i style="color: #0077b5 !important; cursor: pointer" class="fab fa-linkedin"></i
                ></span>
                <div class="location ms-auto">
                  <i class="fas fa-map-marker-alt"></i>
                  <span>{{ job.location.city }}</span>
                  <span> {{ job.location.country }}</span>
                </div>
                <div class="location">
                  <i class="fas fa-handshake"></i>
                  <span>{{ employmentType(job.employment_type) }}</span>
                </div>
                <div class="location">
                  <i class="fas fa-briefcase"></i>
                  <span>{{ showWorkPlace(job.workplace) }}</span>
                </div>
                <div class="location ms-auto">
                  <i class="fas fa-clock"></i>
                  <span>
                    {{
                      job.created_at
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}</span
                  >
                </div>
              </div>
              <!-- End Single Job Post -->
            </div>
            <!-- End Left Col -->
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
// import Pagination from '../Navigations/Pagination';
import axios from 'axios';
import { errorService } from '../../services/errorService';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      isLoading: true,
      applications: [],
    };
  },
  methods: {
    ...mapActions(['retrieveCandidateDocumentPreview']),
    onOpenDocPreview(docId) {
      console.log(docId);
      this.retrieveCandidateDocumentPreview({ uuid: docId }).then(response => {
        const blob = new window.Blob([response.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    },

    openDocPreview(docId, name) {
      const fileExtension = name
        .split('.')
        .pop()
        .toLowerCase();
      const imageFileTypes = ['jpg', 'jpeg', 'png', 'heic'];
      if (imageFileTypes.includes(fileExtension)) {
        this.retrieveCandidateDocumentPreview({ uuid: docId, preview: 'true' })
          .then(response => {
            let mimeType;
            switch (fileExtension) {
              case 'png':
                mimeType = 'image/png';
                break;
              case 'heic':
                mimeType = 'image/heic';
                break;
              default:
                mimeType = 'image/jpeg';
            }

            const blob = new window.Blob([response.data], { type: mimeType });
            const fileURL = window.URL.createObjectURL(blob);

            // Open the image in a new tab
            const newWindow = window.open('', '_blank');
            newWindow.document.write(`
          <html>
            <head>
              <title>Image Preview</title>
            </head>
            <body style="margin:0;">
              <img src="${fileURL}" style="width:100%; height:100%; object-fit:contain;" />
            </body>
          </html>
        `);
            newWindow.document.close();
          })
          .catch(() => {
            this.isCvLoading = false;
          });
      } else {
        this.isCvLoading = true;
        this.retrieveCandidateDocumentPreview({ uuid: docId, preview: 'true' })
          .then(response => {
            this.isCvLoading = false;
            const blob = new window.Blob([response.data], { type: 'application/pdf' });

            const fileURL = window.URL.createObjectURL(blob);

            window.open(fileURL, '_blank').focus();
          })
          .catch(() => {
            this.isCvLoading = false;
          });
      }
    },
    showWorkPlace(data) {
      if (data === 1) {
        return 'Onsite';
      } else if (data === 2) {
        return 'Hybrid';
      } else {
        return 'Remote';
      }
    },
    getJobApplications() {
      axios(`${process.env.VUE_APP_API_URL}/candidate/applications`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          this.isLoading = false;
          this.applications = response.data;
        })
        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    employmentType(employment) {
      if (employment === 1) {
        return 'Employment';
      } else if (employment === 2) {
        return 'Self-employment';
      } else if (employment === 3) {
        return 'Employment / Self-Employment';
      }
    },
  },
  computed: {
    ...mapGetters(['getCandidateDocuments', 'getUserProfile', 'getDocumentPreview']),
  },
  mounted() {
    this.getJobApplications();
    localStorage.setItem('UserJobList', 1);
    localStorage.setItem('UserSearchLocation', []);
    localStorage.setItem('UserSearchKeywords', []);
    localStorage.setItem('UserSearchEmployer', []);
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.card {
  min-height: calc(100vh - 138px);
}

.title-header {
  font-family: Montserrat, Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-weight: bolder;
}

.latest-ads {
  padding: 20px 15px;
  h2 {
    text-transform: uppercase;
    font-size: 21px;
    margin-bottom: 40px;
  }
  .single {
    padding: 5px;
    background: #fff;
    box-shadow: 0px 15px 35px #0000000d;
    margin-bottom: 20px;
    font-family: $font-family-sans-lato;
    img {
      width: 70px;
      height: 70px;
      object-fit: contain;
      object-position: center;
      overflow: hidden;
      margin-right: 12px;
      flex-shrink: 0;
    }
    .job-info {
      width: 37%;
      margin-right: 12px;
      a {
        display: block;
        text-decoration: none;
        &:first-of-type {
          font-size: 18px;
        }
        &:nth-of-type(2) {
          color: #424242;
          font-size: 16px;
        }
      }
    }
    .documents {
      i {
        display: block;
        color: #afafaf;
        font-size: 25px;
        color: #ff0000;
      }
    }
    .location {
      text-align: center;
      width: 110px;
      margin: 0 10px;
      a {
        text-decoration: none;
      }
      i {
        display: block;
        color: #afafaf;
        font-size: 18px;
        margin-bottom: 5px;
      }
      span {
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        text-transform: uppercase;
      }
    }
    .tagline {
      text-align: right;
      width: 200px;
      a {
        display: inline-block;
        background: #f2f2f2;
        border-radius: 16px;
        color: #3e3e3e;
        border: 5px solid #fff;
        font-size: 13px;
        padding: 3px 8px;
        text-decoration: none;
        font-weight: 500;
      }
    }
  }
}
@media only screen and (max-width: 576px) {
  .latest-ads {
    .single {
      display: block !important;
      img {
        display: none;
      }
      .job-info {
        width: 100%;
        margin-bottom: 12px;
      }
      .tagline {
        margin: 12px 0 0 0 !important;
        width: 100%;
        text-align: center;
      }
      .location {
        margin: 0;
        color: #666;
        margin-left: 0 !important;
        text-align: left !important;
        i {
          display: none;
        }
        &:nth-last-of-type(2) {
          text-align: right;
        }
      }
    }
    .ml-auto {
      margin-right: auto !important;
      margin-left: 0 !important;
    }
  }
}
</style>
